import React, { useState, useContext, useEffect } from "react";
import { LangCtx } from "../../../lib/context";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { getSolts, deleteSchedule } from "../../../actions/schedule";
import BtmDeleteSlide from "../../../lib/ui/BtmDeleteSlider";
import CreateSlot from "./CreateSlot";
import SlotListItem from "./SlotListItem";
import ModalAddDays from "./ModalAddDays";
import Loader from "../../../lib/ui/loader/Loader";
import {API} from 'aws-amplify';

const SlotList = (props) => {
    const { l } = useContext(LangCtx);
    const [slot_data, setSlotData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [newopen, setNew] = useState(false);
    const [slideD, setSlideD] = useState(false);
    // const [confirmslideD, setConfirmSlideD] = useState(false);
    // const [confirmText, setConfirmText] = useState(false);
    const [edit, setEdit] = useState(false);
    const [data, setData] = useState(null);
    const [o_days, setOtherDays] = useState([]);

    useEffect(() => {
        loadSlots(props.schData.scheduleId);
        setData(props.schData);
    }, [props.schData]);

    useEffect(() => {
        if (props.schData && props.schData.days && props.existDays) {
            let _d = [...props.schData.days];
            let days = props.existDays.filter((i) => _d.indexOf(i) < -1);
            setOtherDays([...days]);
        }
    }, [props.schData, props.existDays]);

    const loadSlots = (id) => {
        setLoading(true);
        getSolts(id)
            .then((res) => {
                setLoading(false);
                if (res && res.data) {
                    setSlotData([...res.data]);
                } else {
                    setSlotData([]);
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
                setSlotData([]);
            });
    };

    const handleNew = (status) => {
        if (status) {
            loadSlots(props.schData.scheduleId);
        }
        setNew(false);
    };

    // const handleConfirm = () => {
    //     confirmDeleteSchedule(props.schData.scheduleId)
    //         .then((res) => {
    //             setLoading(false);
    //             if (res && res.status) {
    //                 // setConfirmText("");
    //                 setSlideD(true);
    //             } else {
    //                 // setConfirmSlideD((prev) => !prev);
    //                 setSlideD(true);
    //             }
    //         })
    //         .catch((err) => {
    //             setLoading(false);
    //             console.log("err in confirm delete schedule ==== ", err);
    //         });
    // };

    const handleDelete = () => {
        setLoading(true);
        deleteSchedule(props.schData.scheduleId)
            .then((res) => {
                setLoading(false);
                if (res && res.status) {
                    props.reloadData();
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log("err ==== ", err);
            });
    };

    if (data) {
        return (
            <div className="daysCard">
                {loading && <Loader />}
                {/* {confirmslideD && <BtmDeleteSlide slideD={confirmslideD} handleCancel={() => setConfirmSlideD(prevState => !prevState)} txt={confirmText} handleConfirm={handleConfirm} />} */}
                {slideD && (
                    <BtmDeleteSlide
                        slideD={slideD}
                        handleCancel={() => setSlideD((prevState) => !prevState)}
                        txt={l.conf_del}
                        handleConfirm={handleDelete}
                    />
                )}
                <div className="daysCardHdr">
                    <div className="dcHdrItems">
                        <div className="scrlBox">
                            {data &&
                                data.days &&
                                data.days.sort().map((d, i) => (
                                    <div className="dayBox" key={d + i}>
                                        <span>{l.day_names[d]}</span>
                                    </div>
                                ))}
                        </div>
                    </div>
                    <div className="dcHdrActn">
                        <button className="btnTxt sm" onClick={() => setSlideD((prevState) => !prevState)}>
                            <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                            <span>{l.delete}</span>
                        </button>
                        <button className="btnTxt sm" onClick={() => setEdit((prevState) => !prevState)}>
                            <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                            <span>{l.edit}</span>
                        </button>
                    </div>
                </div>
                {edit && (
                    <ModalAddDays
                        openAddDay={edit}
                        handleAddDays={() => setEdit((prevState) => !prevState)}
                        existDays={o_days}
                        selDays={data.days}
                        startDate={data.from}
                        endDate={data.to}
                        id={data.scheduleId}
                        groupId={data.groupId}
                        loadSch={(d) => {
                            setData(d);
                            setEdit((prevState) => !prevState);
                        }}
                    />
                )}
                <div className="inputCardBlock">
                    {loading ? (
                        <AiOutlineLoading3Quarters className="spinner" />  
                    ) : slot_data && slot_data.length > 0 ? (
                        slot_data.map((slot) => (
                            <SlotListItem
                                key={slot.slotId}
                                slotData={slot}
                                reloadData={() => loadSlots(data.scheduleId)}
                                scheduleData={data}
                            />
                        ))
                    ) : (
                        <CreateSlot scheduleId={data.scheduleId} scheduleData={data} handleClose={handleNew} />
                    )}
                    {newopen && <CreateSlot scheduleId={data.scheduleId} scheduleData={data} handleClose={handleNew} />}
                    {slot_data && slot_data.length > 0 && !newopen && (
                        <div className="btnGroup mgT12 flxEnd">
                            <button className="btnFilled sm ripple" onClick={() => setNew((prevState) => !prevState)}>
                                <span>{l.add_slot}</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    } else {
        return <span>loading...</span>;
    }
};

export default SlotList;
